// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"1d1c0447","225":"4ca6b1e8","292":"702bdc0c","453":"117b0875","855":"7e5a6750"}[chunkId] + ".chunk.js";
};